import { IRowRenderType } from "../model";
import { sargamCodec } from "./sargam";
import { simpleCodec } from "./simple";
import { TrackCodec } from "./types";

/**
 * Lookup from track type to its codec.
 *
 * THIS IS THE LIPI SEAM. A new notation system (Paluskar, Karnatic) means:
 *   1. add the variant to `IRowRenderType` in ../model
 *   2. write its codec
 *   3. register it here
 *
 * Nothing else needs to branch. Previously the same knowledge was spread across
 * five `if (trackType === "qwerty-sargam")` checks in four different files.
 *
 * The rule that keeps this cheap: the notation model never learns what a swara
 * IS. A `Cell` stays an opaque `string[]`; only codecs interpret its contents.
 */
const CODECS: Record<IRowRenderType, TrackCodec> = {
    simple: simpleCodec,
    "qwerty-sargam": sargamCodec,
};

/** Falls back to the free-text codec for an unknown/legacy type. */
export function getTrackCodec(type: IRowRenderType | undefined): TrackCodec {
    return (type && CODECS[type]) || simpleCodec;
}

export const allTrackCodecs = (): TrackCodec[] => Object.values(CODECS);
